// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__1rTew","spinnerImage":"LoadingSpinner_spinnerImage__mtZ1A"};